import { Controller } from "@hotwired/stimulus"

// content upload iframe form — data-controller="content--upload"
export default class extends Controller {
  static targets = ["fileInput", "fileName", "submit", "loading"]

  static values = {
    maxFileSize: Number,
    minFileSize: Number,
  }

  connect() {
    this.previousStopUpload = window.stopUpload
    this.previousErrorsLoad = window.errorsLoad
    window.stopUpload = this.stopUpload
    window.errorsLoad = this.errorsLoad

    if (this.hasFileNameTarget) {
      this.fileNameTarget.style.cursor = "default"
    }
  }

  disconnect() {
    if (window.stopUpload === this.stopUpload) {
      if (this.previousStopUpload) {
        window.stopUpload = this.previousStopUpload
      } else {
        delete window.stopUpload
      }
    }

    if (window.errorsLoad === this.errorsLoad) {
      if (this.previousErrorsLoad) {
        window.errorsLoad = this.previousErrorsLoad
      } else {
        delete window.errorsLoad
      }
    }
  }

  chooseFile(event) {
    event.preventDefault()
    this.fileInputTarget.click()
  }

  updateFileName() {
    const file = this.fileInputTarget.files[0]
    if (this.hasFileNameTarget) {
      this.fileNameTarget.value = file ? file.name : ""
    }
  }

  submit(event) {
    event.preventDefault()

    $("#uploading-result").fadeOut()
    $("#uploading-errors").fadeOut()

    const file = this.fileInputTarget.files[0]
    if (!file) return

    if (this.maxFileSizeValue < file.size) {
      this.errorsLoad(`File size should be less than ${this.#formatBytes(this.maxFileSizeValue)}`)
      return
    }

    if (this.minFileSizeValue > file.size) {
      this.errorsLoad(`File size should be greater than ${this.#formatBytes(this.minFileSizeValue)}`)
      return
    }

    this.element.submit()
    this.#startLoadingProcess()
  }

  stopUpload = (blob) => {
    this.#stopLoadingProcess()

    $("#uploading-result").fadeIn()
    $("#blob_name").val(blob.name)
    $("#blob_content_type").val(blob.type)
    $("#size").val(blob.size)
    $("#status").val(blob.blob_status)
    $("#uploading-result .content")
      .empty()
      .append("The file has been successfully uploaded")

    if (this.hasFileInputTarget) this.fileInputTarget.value = ""
    if (this.hasFileNameTarget) this.fileNameTarget.value = ""

    const table = window.oTable
    if (table && typeof table.draw === "function") {
      table.draw(false)
    }
  }

  errorsLoad = (errors) => {
    this.#stopLoadingProcess()

    $("#uploading-errors").fadeIn()
    $("#uploading-errors .content").empty().append(errors)
  }

  #startLoadingProcess() {
    if (this.hasSubmitTarget) {
      this.submitTarget.setAttribute("disabled", "disabled")
    }
    if (this.hasLoadingTarget) {
      $(this.loadingTarget).fadeIn()
    }
  }

  #stopLoadingProcess() {
    if (this.hasSubmitTarget) {
      this.submitTarget.removeAttribute("disabled")
    }
    if (this.hasLoadingTarget) {
      $(this.loadingTarget).fadeOut()
    }
  }

  #formatBytes(bytes) {
    if (bytes === 0) return "0 Bytes"

    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    const index = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, index)).toFixed(0))} ${sizes[index]}`
  }
}
